import { getPlanQueryParameter } from '$lib/core/map/map-mode-store';
import type {
	IMastSelectionRequest,
	IMastSelectionResponse
} from '$lib/models/IMastSelectionModel';
import { get } from 'svelte/store';
import api from './kyAuthenticatedInstance';

export const MastSelectionService = {
	async getSelection(body: IMastSelectionRequest): Promise<IMastSelectionResponse> {
		return api
			.post(`Section/masts/selection` + get(getPlanQueryParameter), { json: body })
			.json<IMastSelectionResponse>();
	}
};
